import type { ScenarioModel } from '@/shared/generated'

import { find } from 'lodash/fp'

import { useScenariosQuery } from '@/entities/scenario'

export function useMainScenarioId(optimizationGroupId?: string) {
	const { data: scenarios } = useScenariosQuery<ScenarioModel | undefined>(
		optimizationGroupId!,
		{
			select: find<ScenarioModel>({ is_main: true }),
			enabled: !!optimizationGroupId,
		}
	)

	return scenarios?.id
}
